import { createI18n } from 'vue-i18n'
import zh from './zh.json'
import en from './en.json'

const messages = {
  zh,
  en,
}

const languageMatch = /\/(en)(?:\/|$)/

let setLanguage = () => {
  let value = window.location.pathname.match(languageMatch)
  if (value?.[1]) {
    return value[1]
  } else {
    return 'zh'
  }
}

const i18n = createI18n({
  legacy: false,
  locale: setLanguage(),
  fallbackLocale: 'zh',
  messages,
})

export default i18n
